import React, { useState } from 'react'
import { Row, Button, Form, FormFeedback } from 'reactstrap'
import Loading from 'Components/Loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { validateEmail, validateDomain } from 'Modules/Utils'
import FieldRouter from 'Components/Personal/Property/propertyForm/FieldRouter'
import PhotoUpload from 'Components/Personal/Property/propertyForm/PhotoUpload'
import { useDispatch } from 'react-redux'
import { refetchUser } from 'store/slices/authSlice'

export default function PropertyForm({
  initValue,
  propertyId,
  property,
  propertyMeta,
  onSubmit,
  closeForm,
  className = '',
  isThumbnail
}) {
  console.log('PropertyForm - property.name:', property.name, 'initValue:', initValue, 'type:', typeof initValue)
  const dispatch = useDispatch()
  const [value, setValue] = useState(initValue || '')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState({})


  const validate = (property, value) => {
    if (property.name === 'birthday') {
      if (!value || !value.trim()) {
        setError({ [property.name]: 'Birthday is required' })
        return false
      }
      return true
    }

    if (property.name === 'emailAddresses') {
      if (!validateEmail(value[1].value)) {
        setError({ [property.name]: { [value[1].name]: 'Invalid email' } })
        return false
      }
      return true
    }

    if (property.name === 'urlAddresses') {
      // prefix https to domain if it is not specified
      if (!value[1].value.match(/^\w+:\/\//)) {
        value[1].value = `https://${value[1].value}`
      }
      if (!validateDomain(value[1].value)) {
        setError({ [property.name]: { [value[1].name]: 'Invalid URL' } })
        return false
      }
      return true
    }

    if (property.name === 'phoneNumbers') {
      if (!value[1].value.trim()) {
        setError({ [property.name]: { [value[1].name]: 'Please enter phone number' } })
        return false
      }
      if (!value[2].value.trim()) {
        setError({ [property.name]: { [value[1].name]: 'Please choose country' } })
        return false
      }
      return true
    }

    if (property.name === 'postalAddresses') {
      const requiredFields = ['street', 'city', 'country']
      for (const i in value) {
        if (requiredFields.includes(value[i].name) && !value[i].value.trim()) {
          setError({ [property.name]: { [value[i].name]: `${value[i].showName} can not be empty` } })
          return false
        }
      }
      return true
    }

    if (typeof value !== 'object') {
      if (!value || String(value).trim() === '') {
        setError({ [property.name]: `${property.showName} can not be empty` })
        return false
      }
      return true
    }
    return true
  }

  const submit = () => {
    setLoading(true)
    setError({})
    if (!validate(property, value)) {
      setLoading(false)
      return false
    }
    onSubmit(property.name, value)
      .catch(err => {
        setError({ apiError: err.message || 'An error occurred' })
        setLoading(false)
      })
  }

  return (
    <Form onSubmit={e => { e.preventDefault(); submit() }}>
      <Row className={className}>
        {loading && <Loading />}

        <div className='flex-grow-1 pl-2'>
          {(isThumbnail || property.name === 'thumbnailImage') ? (
            <PhotoUpload
              onSubmit={async (base64Data) => {
                // Submit the form with the cropped image data
                // For thumbnailImage, the POST /api/users/profile/thumbnail endpoint
                // has already fully saved/updated the photo in the database.
                // We just need to refetch the user to update the UI and close the form.
                await dispatch(refetchUser())
                closeForm()
                return Promise.resolve()
              }}
              currentValue={value}
              propertyId={propertyId}
            />
          ) : (
            <FieldRouter
              value={value}
              setValue={setValue}
              row={property}
              error={error[property.name]}
            />
          )}
          {error.apiError && <FormFeedback className='d-block'>{error.apiError}</FormFeedback>}
        </div>

        <div className='align-self-end mb-2'>
          {property.name !== 'thumbnailImage' && (
            <Button
              color='link'
              aria-label='Save'
              disabled={loading}
              onClick={submit}
            >
              <FontAwesomeIcon icon='check' />
            </Button>
          )}
          <Button
            color='link'
            aria-label='Cancel'
            className='text-muted'
            onClick={closeForm}
            disabled={loading}
          >
            <FontAwesomeIcon icon='times' />
          </Button>
        </div>
      </Row>
    </Form>
  )
}